import { createSlice } from '@reduxjs/toolkit';

const dataSlice = createSlice({
  name: 'data',
  initialState: {
    hurtos: null,
    homicidios: null,
    loading: {
      hurtos: false,
      homicidios: false
    },
    error: null
  },
  reducers: {
    setHurtosData: (state, action) => {
      state.hurtos = action.payload;
    },
    setHomicidiosData: (state, action) => {
      state.homicidios = action.payload;
    },
    setLoading: (state, action) => {
      const { type, status } = action.payload;
      state.loading[type] = status;
    },
    setError: (state, action) => {
      state.error = action.payload;
    }
  }
});

export const { setHurtosData, setHomicidiosData, setLoading, setError } = dataSlice.actions;
export default dataSlice.reducer;